import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-manage-sub-region',
  templateUrl: './manage-sub-region.component.html',
  styleUrl: './manage-sub-region.component.scss'
})
export class ManageSubRegionComponent {

  public selMenu = 'region';
  public assignCategoryList: Array<any> = [];
  public allList: Array<any> = [];
  public allRegionList: Array<any> = [];
  public mappingList: Array<any> = [];
  public selected: any;
  public commonModal: any = null;
  public name: string = '';
  public image: string = '';
  public metadata: string = '';
  public schema: string = '';

  public imgUrl = environment.ImageUrl;
  public imageBase64: string | ArrayBuffer;
  public postalCodeList: Array<any> = [""];
  public postalCodeValue: Array<any> = [""];

  constructor(private auth: AuthServiceService, private modalService: NgbModal, private toastr: ToastrService) { }

  ngOnInit(): void {
    this.getAllList();
  }

  public add(modal: any, selected: any = null) {
    this.postalCodeList = [""];
    this.postalCodeValue = [""];


    if (selected) {
      console.log(selected, "SELECTED BROW")
      this.name = selected?.name;
      this.image = selected?.image;
      this.schema = selected?.schema;
      this.metadata = selected?.metadata;
      this.selected = selected;
      if (selected.postalCode && selected.postalCode.length > 0) {
        this.postalCodeList = structuredClone(selected.postalCode);
        this.postalCodeValue = structuredClone(selected.postalCode);
      }


    } else {
      this.selected = null;
      this.name = "";
      this.schema = "";
      this.metadata = "";
    }
    this.commonModal = this.modalService.open(modal, { size: "sm", ariaLabelledBy: "modal-basic-title", backdrop: "static" });
  }

  public getAllList() {
    this.auth.getMemberShopSubRegion().subscribe((resp: ApiResponse) => {
      this.allList = resp.body.map((i) => {
        try {
          i['postalCode'] = JSON.parse(i['postalCode'])
        } catch (e) {
          i['postalCode'] = [];
        }
        return i;
      });
    });
    this.auth.getMemberShopRegion().subscribe((resp: ApiResponse) => {
      this.allRegionList = resp.body;
    })
    this.auth.getRegionMapping().subscribe((resp: ApiResponse) => {
      this.mappingList = resp.body.map(i => i.subRegionId);
    })
  }

  public deleteSub(id: any) {
    ((this.selMenu == 'region') ? this.auth.deleteMemberShopRegion(id) : this.auth.deleteMemberShopSubRegion(id)).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this.commonModal ? this.commonModal.close() : '';
      this.getAllList();
    })
  }

  public deleteMapping(id: any) {
    this.auth.deleteRegionMapping(id).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this.getAllList();
    })
  }

  public AddEditCategorySubmit() {




    let formData = new FormData();
    typeof this.image == "string" ? "" : formData.append("image", this.image);
    formData.append("name", this.name.trim());

    if (this.selected?.subRegionId) {
      formData.append("subRegionId", this.selected?.subRegionId);
    }

    if (this.selected?.regionId) {
      formData.append("regionId", this.selected?.regionId);
    }
    if (this.metadata) {
      formData.append("metadata", this.metadata);
    }
    if (this.schema) {
      try {
        JSON.parse(this.schema)
        formData.append("schema", this.schema);
      } catch (e) {
        this.toastr.error("Invalid Schema Json Format")
        return;
      }
    }

    if (this.selMenu != 'region') {
      this.postalCodeValue = this.postalCodeValue.map(i => i.trim());
      formData.append("postalCode", JSON.stringify(this.postalCodeValue.filter((i) => i)));
    }

    ((this.selMenu != 'region') ? this.auth.addMemberShopSubRegion(formData) : this.auth.addMemberShopRegion(formData)).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this.commonModal ? this.commonModal.close() : '';
      this.getAllList();
      this.name = '';
      this.image = '';
      this.selected = null;
      this.imageBase64 = null;
    }, ({ error }) => {
      this.toastr.error(error.message);
    });
  }

  public saveProductCharSelectedImage(event) {
    this.selected ? (this.selected.image = null) : "";
    let file = event.target.files[0];
    let fileReader = new FileReader();
    fileReader.onload = () => {
      this.imageBase64 = fileReader.result;
      this.image = file;
    };
    fileReader.readAsDataURL(file);
  }


  public selectMenu(menu: string) {
    this.selMenu = menu;
  }

  public openAssign(modal: any, selected: any) {

    this.assignCategoryList = this.allList.map((i) => {
      return { ...i, checked: (selected.subRegions.filter(j => j.subRegionId == i.subRegionId).length > 0) };
    }).filter((i: any) => !this.mappingList.includes(i.subRegionId));

    this.selected = selected;
    this.commonModal = this.modalService.open(modal, { size: "sm", ariaLabelledBy: "modal-basic-title", backdrop: "static" });
  }

  public assignRelationshipSubmit(modal: any) {


    let apiList = [];
    this.assignCategoryList.filter(i => i.checked).map((i) => {
      if (this.selected.regionId != i.regionId && (this.selected.subRegions.filter(j => j.subRegionId == i.subRegionId).length == 0)) {
        apiList.push(this.auth.addRegionMapping({ regionId: this.selected.regionId, subRegionId: i.subRegionId }));
      }
    });

    if (apiList && apiList.length > 0) {
      forkJoin(apiList).subscribe((resp: any) => {
        this.toastr.success(resp[0].message);
        this.getAllList();
        this.commonModal.close();
      });
    }
  }

  public addPostalCode() {
    this.postalCodeList.push("");
    this.postalCodeValue.push("");
  }

  onPostalCodeChange(index: number): void {
    const postalCode = this.postalCodeList[index];
    if (postalCode && postalCode.trim() === '') {
      // Handle empty postal code here, e.g., show a warning or reset
      this.postalCodeList[index] = ''; // Trim empty spaces
    }
    // Additional logic if needed
  }
}
